/* Make horizontally overflowing department navigation discoverable and operable. */
(() => {
  const controllers = new WeakMap();
  const compact = window.matchMedia('(min-width: 1000px) and (max-width: 1359px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(scope) {
    scope.querySelectorAll('[data-ff-nav-scroller]').forEach((container) => {
      if (controllers.has(container)) return;
      const list = container.querySelector('.nav-bar__linklist');
      const previous = container.querySelector('[data-ff-nav-scroll="previous"]');
      const next = container.querySelector('[data-ff-nav-scroll="next"]');
      if (!list || !previous || !next) return;
      let frame = 0;
      let disposed = false;

      function update() {
        frame = 0;
        if (disposed) return;
        const links = Array.from(list.querySelectorAll(':scope > .nav-bar__item > .nav-bar__link'));
        const boxes = links.map((link) => link.getBoundingClientRect()).filter((box) => box.width > 0);
        const style = getComputedStyle(container);
        const available = container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const first = boxes[0];
        const last = boxes[boxes.length - 1];
        // Direct link bounds exclude the absolutely positioned dropdown panels.
        const overflow = compact.matches && first && last && last.right - first.left > available + 1;
        container.toggleAttribute('data-overflow', Boolean(overflow));
        previous.hidden = next.hidden = !overflow;
        if (!overflow) return;
        const viewport = list.getBoundingClientRect();
        previous.disabled = first.left >= viewport.left - 1;
        next.disabled = last.right <= viewport.right + 1;
      }

      function schedule() {
        if (!disposed && !frame) frame = requestAnimationFrame(update);
      }

      function scroll(event) {
        const direction = event.currentTarget === previous ? -1 : 1;
        list.scrollBy({ left: direction * list.clientWidth * .75, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      const observer = new ResizeObserver(schedule);
      observer.observe(container);
      observer.observe(list);
      list.addEventListener('scroll', schedule, { passive: true });
      list.addEventListener('focusin', schedule);
      previous.addEventListener('click', scroll);
      next.addEventListener('click', scroll);
      compact.addEventListener('change', schedule);
      if (document.fonts) document.fonts.ready.then(schedule);
      controllers.set(container, () => {
        disposed = true;
        cancelAnimationFrame(frame);
        observer.disconnect();
        list.removeEventListener('scroll', schedule);
        list.removeEventListener('focusin', schedule);
        previous.removeEventListener('click', scroll);
        next.removeEventListener('click', scroll);
        compact.removeEventListener('change', schedule);
        controllers.delete(container);
      });
      schedule();
    });
  }

  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ff-nav-scroller]').forEach((container) => controllers.get(container)?.());
  });
})();
